<template>
  <div :class="[`view-112`, className || ``]">
    <div class="view-113">
      <div class="view-114">
        <img
          class="vector-114"
          src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-573.svg"
          alt="Vector"
        />
        <img
          class="vector-115"
          src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-573.svg"
          alt="Vector"
        />
        <img
          class="vector-116"
          src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-575.svg"
          alt="Vector"
        />
      </div>
      <view612 />
    </div>
  </div>
</template>

<script>
import View612 from "./View612";
export default {
  name: "View602",
  components: {
    View612,
  },
  props: ["className"],
};
</script>

<style>
.view-112 {
  align-items: flex-start;
  background-color: var(--cornflower-2);
  display: flex;
  height: 101px;
  justify-content: flex-end;
  left: 1779px;
  min-width: 134px;
  padding: 31px 46px;
  position: absolute;
  top: 60px;
}

.view-113 {
  height: 38px;
  position: relative;
  width: 41px;
}

.view-114 {
  aspect-ratio: 1;
  background-image: url(https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-572.svg);
  background-size: 100% 100%;
  height: 92.11%;
  left: 0;
  position: absolute;
  top: 7.89%;
  width: 85.37%;
}

.vector-114 {
  height: 10%;
  left: 65%;
  position: absolute;
  top: 45%;
  width: 10%;
}

.vector-115 {
  height: 10%;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 10%;
}

.vector-116 {
  height: 10%;
  left: 24.99%;
  position: absolute;
  top: 45%;
  width: 10%;
}

.view-112.view-118 {
  left: 1428px;
  top: 0;
}
</style>
